import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { logger } from '../utils/logger'

import HomeView from '../views/HomeView.vue'
import AuthCallback from '../views/AuthCallback.vue'
import ChannelsView from '../views/ChannelsView.vue'
import SummariesView from '../views/SummariesView.vue'
import ChannelDetailView from '../views/ChannelDetailView.vue'
import SettingsView from '../views/SettingsView.vue'
import AdminReports from '../views/AdminReports.vue'
import AdminChannelSummaries from '../views/AdminChannelSummaries.vue'
import AdminYouTubeComments from '../views/AdminYouTubeComments.vue'
import PublicVideoView from '../views/PublicVideoView.vue'
import PublicChannelView from '../views/PublicChannelView.vue'
import NotFound from '../views/NotFound.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: AuthCallback
    },
    {
      path: '/channels',
      name: 'channels',
      component: ChannelsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/popular-channels',
      name: 'popularChannels',
      component: ChannelsView,
      meta: { requiresAuth: false }
    },
    {
      path: '/summaries',
      name: 'summaries',
      component: SummariesView,
      meta: { requiresAuth: true }
    },
    {
      path: '/channels/:id',
      name: 'channelDetail',
      component: ChannelDetailView,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: SettingsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/reports',
      name: 'adminReports',
      component: AdminReports,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/channel-summaries',
      name: 'adminChannelSummaries',
      component: AdminChannelSummaries,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/youtube-comments',
      name: 'adminYouTubeComments',
      component: AdminYouTubeComments,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/video/:videoId/:lang?',
      name: 'public-video',
      component: PublicVideoView,
      meta: { requiresAuth: false }
    },
    {
      path: '/video/:slug/:lang?',
      name: 'public-video-seo',
      component: PublicVideoView,
      meta: { requiresAuth: false }
    },
    {
      path: '/channel/:channelId',
      name: 'public-channel',
      component: PublicChannelView,
      meta: { requiresAuth: false }
    },
    {
      path: '/channel/:channelSlug/:channelId',
      name: 'public-channel-seo',
      component: PublicChannelView,
      meta: { requiresAuth: false }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: NotFound,
      meta: { requiresAuth: false }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  logger.info('Route navigation:', {
    to: to.path,
    from: from.path,
    requiresAuth: to.meta.requiresAuth
  })

  // Auth callback route'unu her zaman izin ver
  if (to.name === 'auth-callback') {
    logger.info('Allowing auth callback route')
    next()
    return
  }

  // Protected route'lar için auth kontrolü
  if (to.meta.requiresAuth) {
    logger.info('Protected route, checking auth...')
    await authStore.checkUser()
    
    if (!authStore.user) {
      logger.info('No authenticated user, redirecting to home')
      next('/')
      return
    }
  }

  // Admin guard: only allow specific email
  if (to.meta && (to.meta as any).requiresAdmin) {
    const email = (authStore.user as any)?.email || ''
    const adminEmail = (import.meta as any).env?.VITE_ADMIN_EMAIL || 'metinarab@gmail.com'
    if (!email || email.toLowerCase() !== String(adminEmail).toLowerCase()) {
      logger.warn('Non-admin attempted to access admin route')
      next('/')
      return
    }
  }
  
  next()
})

// Google Analytics için sayfa görüntüleme takibi
router.afterEach((to) => {
  if (typeof gtag !== 'undefined') {
    gtag('config', 'G-YQDLP55WYW', {
      page_path: to.fullPath
    })
  }
})

export default router 